import styled from '@emotion/styled';
import {Box} from '@mui/material';
import {Section, TestimonialsSection} from '../../../../api/models';
import {AddNewTestimonial} from './AddNewTestimonial';
import {TestimonialComponent} from './TestimonialComponent';

const BackgroundBoxWrapper = styled(Box)<{backgroundColor: string}>(({backgroundColor}) => ({
    // paddingTop: 32,
    paddingLeft: 54,
    paddingRight: 54,
    paddingBottom: 32,
    margin: 0,
    backgroundColor: backgroundColor,
}));

interface Props {
    section: Section;
    websiteId: string;
    throwSnackbarMessage: (message: string) => void;
    refetch: VoidFunction;
}

export const TestimonialsCompanionComponent = (props: Props) => {
    const testimonials = (props.section as TestimonialsSection).testimonials;

    return (
        <div>
            <BackgroundBoxWrapper backgroundColor={'white'}>
                <AddNewTestimonial refetch={props.refetch} throwSnackbarMessage={props.throwSnackbarMessage} />
                <br />
                {testimonials.map((testimonial) => {
                    return <TestimonialComponent testimonial={testimonial} />;
                })}
            </BackgroundBoxWrapper>
        </div>
    );
};
